import React from "react";
import { useSelector } from "react-redux";

import LeadForm from "../lead-search/LeadForm";

const Info = ({ setActiveTab }) => {
  const leadDetail = useSelector(
    (state) => state.LeadDetailsReducer.leadDetails
  );

  const redirectToTimline = () => {
    setActiveTab("1");
  };

  return (
    <>
      <h3 className="heading24px p-20 fw-semibold text-color-1C1C1C">
        Lead Details
      </h3>

      <LeadForm initialValues={leadDetail} closeModal={redirectToTimline} />
    </>
  );
};

export default Info;
